export default __webpack_public_path__ + "static/media/54t.22342f32.jpg";